import React, { useState } from "react";
import Slider from "react-slick";
import { Link, useNavigate } from "react-router-dom";
import videoIcon from "../../../Assets/Icons/video-icon.svg";
import Modal from "react-modal";
import ReactPlayer from "react-player";

import RatingModal from "Pages/Booking/Components/RatingModal";
import { useSelector } from "react-redux";

const Testimonials = ({ data }) => {
  const [showModal, setShowModal] = useState("");
  const [activeModal, setActiveModal] = useState(false);
  const [openRatingModal, setOpenRatingModal] = useState(false);
  const { token } = useSelector((state) => state.login);
  const navigate = useNavigate();

const settings = {
  arrows: false,
  dots: false, // Ensure dots are enabled
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1, // Always scroll one slide to avoid mismatch
  lazyLoad: true, // Disable lazy loading to prevent delayed rendering
  infinite: false, // Enable infinite scrolling for a seamless experience
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1, // Ensure only one slide scrolls on small screens
        dots: true
      }
    }
  ]
};

  const handleOpenModal = (val) => {
    setActiveModal(val);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setShowModal("");
  };

  const handleShareExperience = () => {
    if (token) {
      setOpenRatingModal(true);
    } else {
      navigate("/login");
    }
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className="section-heading">
            <h2>Happy Customers</h2>
            {/* {data?.length >= 4 && (
              <Link className={"viewall-btn"} to={"/testimonials"}>
                View All
              </Link>
            )} */}
          </div>
        </div>
        <div className="col-12">
          {data?.length > 0 && (
            <Slider
              {...settings}
              className="happy-customer-content"
            >
              {data?.map((item) => (
                <div
                  key={item.testimonial_id}
                  className="happy-customer-item"
                >
                  <figure
                    className="happy-customer-image"
                    onClick={() =>
                      handleOpenModal(item.testimonial_id + '-testimonial')
                    }
                  >
                    <div className="video-icon">
                      <img
                        src={videoIcon}
                        alt={'Play Icon'}
                      />
                    </div>
                    <img
                      src={item.image}
                      alt={item.image}
                    />
                    <figcaption>
                      <div className="happy-customers-name">{item?.name}</div>
                      <p>{item?.location}</p>
                    </figcaption>
                  </figure>
                  <Modal
                    isOpen={
                      showModal &&
                      activeModal == item.testimonial_id + '-testimonial'
                        ? true
                        : false
                    }
                    className="full-screen-video-modal"
                    ariaHideApp={false}
                    onRequestClose={handleCloseModal}
                  >
                    <div className="content video-modal-iframe">
                      <button
                        className="close"
                        onClick={handleCloseModal}
                      >
                        X
                      </button>
                      <ReactPlayer
                        url={item?.video_url}
                        controls={true}
                        config={{
                          youtube: {
                            playerVars: { showinfo: 1 }
                          }
                        }}
                      />
                    </div>
                  </Modal>
                </div>
              ))}
            </Slider>
          )}
        </div>
        <div className="col-12">
          <div className="text-center">
            <span
              onClick={handleShareExperience}
              className="btn btn-right-arrow"
            >
              <span>Share Your Experience</span>
            </span>
          </div>
        </div>
      </div>
      <RatingModal
        showModal={openRatingModal}
        handleCloseModal={() => setOpenRatingModal(false)}
      />
    </div>
  );
};

export default Testimonials;
